// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1o1fA","obliqueLineWrap":"membershipbadge_obliqueLineWrap__30qve","obliqueLine":"membershipbadge_obliqueLine__2VDSB"};